import Controller from "./Controller";
import ControllerNarrow from "./ControllerNarrow";
import { Props } from "./models";

const ControllerContent = (props: Props) => {
	return props.isNarrow ? <ControllerNarrow {...props} /> : <Controller {...props} />;
};

export default ControllerContent;
